import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import ProductItem from "./ProductItem";
import { IconPlus } from '@tabler/icons-react'
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";

const Products = forwardRef(
  function Products(props, ref) {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    useEffect(() => {
      if (props.data) {
        setProductsData(props.data);
      }
    }, [props.data]);

    useEffect(() => {
      if (props.categories) {
        setCategories(props.categories);
      }
    }, [props.categories]);

    const setProductsData = (data) => {
      let productsData = [];
      data.forEach((item, index) => {
        productsData.push({
          id: item.id ?? Math.floor((Math.random() * 10000) + 1),
          title: item.title,
          youtubeLink: item.youtubeLink,
          ecommerceLink: item.ecommerceLink,
          category: item.category,
          description: item.description,
          isPrimary: item.isPrimary ?? false,
          show: index == 0,
          isValid: false,
          ref: null
        })
      });

      setProducts(productsData);
    }

    const handleAddProduct = () => {
      let product =
      {
        id: Math.floor((Math.random() * 10000) + 1),
        title: "Product " + (products.length + 1),
        youtubeLink: "",
        ecommerceLink: "",
        isPrimary: false,
        show: true,
        isValid: false,
        ref: null
      }

      setProducts(currentProducts => {
        currentProducts.forEach((product) => {
          product["show"] = false;
        });
        let newProducts = [product, ...currentProducts];
        return newProducts
      });
    }

    const showHideProduct = (index) => {
      const currentProducts = [...products];

      currentProducts.forEach((product, innerIndex) => {
        if (index == innerIndex)
          product["show"] = !product["show"];
        else
          product["show"] = false;
      });

      setProducts(currentProducts);
    }

    const deleteProductHandler = (targetIndex) => {
      const filteredProducts = products.filter((item, index) => index !== targetIndex);

      if (filteredProducts.length == 1 || targetIndex == 0 && filteredProducts.length > 0) {
        filteredProducts[0]["show"] = true;
      }
      else {
        filteredProducts.forEach((product, index) => {
          if (index == targetIndex - 1)
            product["show"] = true;
        });
      }
      setProducts(filteredProducts);
    }

    const validate = () => {
      let isValid = true;
      const currentProducts = [...products];
      currentProducts.forEach(product => {
        let validationStatus = product.ref?.validate() ?? false;
        product["isValid"] = validationStatus;

        if (!validationStatus) {
          isValid = false;
        }
      });
      setProducts(currentProducts);
      return isValid;
    }

    const getData = () => {
      let productsData = [];

      products.forEach(product => {
        let data = product.ref?.getData() ?? null;
        if (data)
          productsData.push(data);
      });

      return productsData;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    const setAsPrimaryHandler = (targetIndex) => {
      const filteredProducts = [...products];
      filteredProducts.forEach((product, index) => {
        if (index == targetIndex)
          product["isPrimary"] = true;
        else
          product["isPrimary"] = false;
      });
      setProducts(filteredProducts);
    }

    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Products</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            <button className="btn btn-primary align-middle" onClick={handleAddProduct}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Product
            </button>
          </div>
        </div>
        <form>
          <div className="row g-3">
            <div className="accordion mt-3">
              {
                (!products || (products && products.length == 0)) && (
                  <div className="row justify-content-center">
                    <div className="col-md-5 col-lg-4 col-11">
                      <div className="d-flex flex-column align-items-center">
                        <img src="/images/nodata.svg" />
                        <div className="helper-message">
                          No Products information<br /> Get started by creating
                        </div>
                        <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleAddProduct}>
                          <IconPlus className="me-sm-1 me-0" size={20} />
                          Add Product
                        </button>
                      </div>
                    </div>
                  </div>
                )
              }

              {products && products.length > 0 &&
                products.map((product, index) => {
                  return (
                    <ProductItem
                      data={product}
                      index={index}
                      showHideProduct={showHideProduct}
                      deleteProduct={deleteProductHandler}
                      setAsPrimary={setAsPrimaryHandler}
                      key={product.id}
                      ref={el => product.ref = el}
                      showDelete={true}
                      categories={categories} />
                  )
                })
              }
            </div>

            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
          </div>
        </form>
      </div>
    )
  });

export default Products;
